import useTeamById from './useTeamById';
import useProjectById from './useProjectById';

const useProjectByTeamId = teamId => {
  const team = useTeamById(teamId);
  const teamProject = useProjectById(team?.project_id);

  return teamProject;
};

export default useProjectByTeamId;
